<template>
  <div :style="items.length > 0 ? 'height:320px;': 'height:175px;'">
    <div v-if="loading && items.length === 0"  style="height:200px;display:flex;align-items: center;">
      <v-row>
      <v-col cols="12" align="center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        </v-col>
      </v-row>
    </div>
    <div
      class="mx-auto"
      max-width="1600"
      style="display: flex; justify-content: center;background-color: white;"
      :style="';margin-top:10px;'"
      v-if="items.length === 0 && !loading"
    >
      <div
        class="ma-4"
        width="270"
        height="180"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 130px;
        "
      >
        <div style="color: #808588ff; font-size: 20px; font-weight: bold">
          {{ $t("message.notHavepromotion") }}
          <v-icon
            style="margin-bottom: 9px;"
            class="iconify"
            data-icon="fluent:megaphone-loud-24-filled"
          ></v-icon>
        </div>
      </div>
    </div>
    <div>
      <v-slide-group v-if="items.length > 0" class="mt-0">
        <v-slide-item
          v-for="(item, i) in items" :key="i" v-slot="{ active }"
          style="border-radius:0px !important;"
        >
        <v-card
            class="pa-3 mr-5"
            max-width="204"
            min-width="204"
            @click="openPromotion(item)"
          >
            <v-img
              style="border-radius: 10px"
              height="180"
              contain
              :src="item.promotionPicture"
            ></v-img>
            <v-card-title v-if="$i18n.locale === 'th' || !item.promotionNameEng || item.promotionNameEng === '' || item.promotionNameEng === null" style="font-size: 15px;min-height: 64px;" class="pa-0">{{item.promotionName ? item.promotionName.substring(0, 52) + '...' : ''}}</v-card-title>
            <v-card-title v-else style="font-size: 15px;min-height: 64px;" class="pa-0">{{item.promotionNameEng.substring(0, 52) + '...'}}</v-card-title>

            <v-card-text>
            </v-card-text>
            <v-card-actions>
              <v-btn
                :style="'background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);color:' + $textcolor"
                dark
                block
                @click="openPromotion(item)"
              >
                {{ item.packageId && item.packageId !== 'None' ?  $t("message.buyPackage") : $t("message.viewDetails") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </div>
      <!-- dialog promotion -->
      <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
    >
      <v-card>
        <v-toolbar
          dark
          :style="'background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);' + 'color:' + $textcolor"
        >
          <v-toolbar-title>{{ $t("message.promotion") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="dialog = false"
            >
              <v-icon :style="'color:' + $textcolor">mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container class="pt-5" v-if="detailPromotion" height="100%">
      <v-card
        class="mx-auto rounded-lg"
        elevation="2"
        height="100%"
      >
        <v-img contain min-height="280" class="white--text align-end" :src="detailPromotion.promotionPicture"
        >
        </v-img>
        <v-container fluid>
          <div v-if="detailPromotion.useInBranch && detailPromotion.useInBranch !== '' && detailPromotion.useInBranch !== 'None'">
            <div class="d-flex mb-1">
              <v-icon class="mr-2" :color="$bgColor">mdi-store</v-icon>
              <p class="mb-0" style="font-weight: bold">สาขาที่สามารถแพ็กเกจใช้ได้</p>
            </div>
            <div class="d-flex mb-5" style="flex-wrap: wrap;">
              <div class="mr-2" v-for="(item, i) in detailPromotion.useInBranch" :key="i">
                <v-chip class="mb-1 mt-1">{{item}}</v-chip>
              </div>
            </div>
          </div>
          <v-row v-if="$i18n.locale === 'th' || !detailPromotion.promotionNameEng || detailPromotion.promotionNameEng === '' || detailPromotion.promotionNameEng === null">
              <v-col class="headline1 bold font18">{{detailPromotion.promotionName}}</v-col>
          </v-row>
          <v-row v-else>
              <v-col class="headline1 bold font18">{{detailPromotion.promotionNameEng}}</v-col>
          </v-row>
          <!-- <v-row v-if="$i18n.locale === 'en'">
              <v-col class="headline1 bold font18">{{detailPromotion.promotionNameEng}}</v-col>
          </v-row> -->
          <!-- <v-row v-if="detailPromotion.promotionSubName">
              <v-col class="headline1 bold font14 pt-0"><nl2br tag="p" :text="detailPromotion.promotionSubName" /></v-col>
          </v-row> -->
          <v-row v-if="$i18n.locale === 'th' || !detailPromotion.promotionDetailsEng || detailPromotion.promotionDetailsEng === '' || detailPromotion.promotionDetailsEng === null">
            <v-col class="icon2 font14" v-html="makeLinksClickable(detailPromotion.promotionDetails)"></v-col>
          </v-row>
          <v-row v-else>
              <v-col class="icon2 font14" v-html="makeLinksClickable(detailPromotion.promotionDetailsEng)"></v-col>
          </v-row>
        </v-container>
        <v-card-actions :style="'background-color:' + this.$bgColor" v-if="detailPromotion.packageId && detailPromotion.packageId !== 'None'">
          <v-btn
            class="rounded-lg"
            text
            block
            dark
            :disabled="canbuy"
            v-if="detailPromotion.packageId && detailPromotion.packageId !== 'None' && detailPromotion.packagePrice !== '0'"
             @click="pushTobuyPackage(detailPromotion)"
          >
          {{ $t("message.buyPackage") }}
          </v-btn>
          <v-btn
            class="rounded-lg"
            text
            block
            dark
            :disabled="canbuy"
            v-if="detailPromotion.packageId && detailPromotion.packageId !== 'None' && detailPromotion.packagePrice === '0'"
            @click="getFreePackage()"
          >
          {{ $t("message.freePackage") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import Flickity from 'vue-flickity'
import Swal from 'sweetalert2'
// import Flickity from 'flickity'

// import { VueperSlides, VueperSlide } from 'vueperslides'
// import 'vueperslides/dist/vueperslides.css'

export default {
  name: 'PromotionHome',
  components: {
    Flickity
    // VueperSlides,
    // VueperSlide
  },
  data () {
    return {
      items: [],
      profile: null,
      session: this.$session.getAll(),
      loading: true,
      slides: [
        'First',
        'Second',
        'Third',
        'Fourth',
        'Fifth'
      ],
      shopId: null,
      flickityOptions: {
        initialIndex: 3,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        imagesLoaded: true
        // any options from Flickity can be used
      },
      slide: [],
      dialog: false,
      detailPromotion: null,
      canbuy: false,
      createQRcodePackage: {
        packageId: '',
        status: 'waiting',
        CREATE_USER: '',
        liffId: '',
        LAST_USER: '',
        shopId: '',
        CREATE_DATE: '',
        chkQRCode: 1
      },
      branchLoyalty: [],
      mapDataBranch: {}
    }
  },
  computed: {
    newDataMember () {
      return this.GET_MEMBERINFO()
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.shopId = this.GET_SHOPID()
    this.theme = this.GET_THEME()
    this.profile = this.getLiffProfile()
    await this.checkliff()
    await this.getBranch()
    await this.getPromotion()
    window.scrollTo(0, document.body.scrollHeight)
  },
  beforeDestroy () {
    this.flickity.destroy()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_THEME']),

    async getBranch () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/get?shopId=' +
            this.shopId
        )
        .then(async (response) => {
          if (response.data.status !== false) {
            this.branchLoyalty = response.data
            this.branchLoyalty.forEach((item) => {
              this.mapDataBranch[item.masBranchID] = item.masBranchName
            })
            // this.detailPromotion.forEach((item) => {
            //   if (item.useInBranch && item.useInBranch !== '') {
            //     item.useInBranch = JSON.parse(item.useInBranch)
            //   }
            // })
          }
        })
        .catch((error) => {
          console.error('error function getBranchBelink : ', error)
          this.Branch = []
        })
    },
    makeLinksClickable (text) {
      // eslint-disable-next-line no-useless-escape
      const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
      const linkedText = text.replace(urlPattern, '<a href="$1" target="_blank">$1</a>')
      const textWithBreaks = linkedText.replace(/\n/g, '<br>')
      return textWithBreaks
    },
    async getPromotion () {
      this.items = []
      const result = await axios.get(
        this.DNS_IP +
          `/promotion/get?RECORD_STATUS=N&shopId=${this.shopId}`,
        { headers: { lineUserId: this.profile.userId, shopId: this.shopId } }
      )
      // const result = await this.callBeTaskAPI('get', `/promotion/get?RECORD_STATUS=N&shopId=${this.session.shopId}`)
      if (Array.isArray(result.data)) {
        this.items = result.data.filter(item => {
          if (item.promotionExpiryDate && item.promotionExpiryDate !== '' && item.promotionExpiryDate !== null && item.promotionExpiryDate !== 'None') {
            return new Date(item.promotionExpiryDate) > new Date()
          } else {
            return item
          }
        })
        this.loading = false
      } else {
        this.loading = false
        this.items = []
      }
      // this.items.forEach(element => {
      //   console.log('testja', element)
      //   let a = {
      //     image: element.promotionPicture,
      //     desc: 'https://picsum.photos/944/775/?image=63'
      //   }
      //   this.slide.push(a)
      // })
      // console.log('thsi.slide', this.items)
      // const para = document.createElement('v-img')
      // para.className = 'carousel-cell'
      // para.src = 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/82/leaf-droplets.jpg'
      // console.log('para', para)
      // document.getElementById('colasel').appendChild(para)
      // const nodes = document.getElementsByTagName('flickity')
      // console.log('aaaaaa', nodes)
    },
    pushTobuyPackage (detailPromotion) {
      this.dialog = false
      if (this.shopId === 'U97dd281445cde30a599a5f5515a4e937' || this.shopId === 'U60f3a4215c86a978d5f6191292ad0109' || this.shopId === 'Ud4b2ccbf4ca8c45196c1b0379629454f' || this.shopId === 'SD_1702096238527') {
        this.$router.push(`/BuyPackage/${detailPromotion.packageId}?shopId=${this.shopId}`)
      } else {
        window.location = `/BuyPackage/${detailPromotion.packageId}?shopId=${this.shopId}`
      }
      // window.location = `/BuyPackage/${detailPromotion.packageId}?shopId=${this.shopId}`
      // this.$router.push('/BuyPackage')
    },
    a () {
      setTimeout(() => 4000)
    },
    async openPromotion (item) {
      try {
        this.detailPromotion = item
        if (this.detailPromotion.useInBranch && this.detailPromotion.useInBranch !== '' && this.detailPromotion.useInBranch !== 'None' && this.detailPromotion.useInBranch !== null) {
          if (typeof this.detailPromotion.useInBranch === 'string') {
            this.detailPromotion.useInBranch = JSON.parse(this.detailPromotion.useInBranch)
            if (this.detailPromotion.useInBranch.length > 0) {
              this.detailPromotion.useInBranch.forEach((item, index) => {
                this.detailPromotion.useInBranch[index] = this.mapDataBranch[item]
              })
            } else {
              this.detailPromotion.useInBranch = null
            }
          } else {
          }
        }
        this.dialog = true
        if (item.limitPackage.toLowerCase() === 'true') {
          const resultPro = await this.callBeTaskAPI('get', `/PackageLog/get?packageId=${item.packageId}&memberId=${this.profile.memberId}`)
          if (Array.isArray(resultPro)) {
            for (let i = 0; i < resultPro.length; i++) {
              const currentItem = resultPro[i]
              if (currentItem.status === 'get' || currentItem.status === 'use') {
                this.canbuy = true
                break
              } else if (currentItem.status === 'cancel') {
                this.canbuy = false
              }
            }
          } else {
            this.canbuy = false
          }
        }
      } catch (error) {
        console.error('glglgglgl', error)
      }
    },
    async getFreePackage () {
      // console.log('test')
      this.createQRcodePackage.packageId = this.detailPromotion.packageId
      this.createQRcodePackage.CREATE_USER = this.profile.userId
      this.createQRcodePackage.LAST_USER = this.profile.userId
      this.createQRcodePackage.memberId = this.profile.memberId
      this.createQRcodePackage.liffId = this.$liffId
      this.createQRcodePackage.shopId = this.shopId
      this.createQRcodePackage.masBranchID = ''
      await axios
        .post(this.DNS_IP + '/packageQRcode/add', this.createQRcodePackage)
        .then(async response => {
          // console.log('addDataGlobal DNS_IP + PATH + "add"', response)
          const paramsCollectPackage = {
            'token': response.data.token
          }
          let config = {
            headers: {
              shopId: this.shopId,
              lineId: this.profile.userId,
              memberId: this.profile.memberId
            }
          }
          await axios
            .post(
              this.DNS_IP +
                '/collect_package/edit',
              paramsCollectPackage, config
            )
            .then(response => {
              this.loaded = false
              Swal.fire({
                title: 'รับแพ็กเกจสำเร็จ',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: 'ตกลง'
              }).then((confirm) => {
                if (confirm.isConfirmed) {
                  this.$router.push('/MyPackage')
                }
              })
              // console.log('res', res)
              // console.log('assign', this.veiwQRCode)
            })
          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // this.loadingAdd = false
        })
        .catch(error => {
          console.error('error function addDataGlobal : ', error)
          this.$router.push(
            '/system/Errorpage?returnLink=' + this.returnLink
          )
          this.dataReady = true
        })
    },
    async checkliff () {
      const result = await axios.get(this.DNS_Link + `/lineconfig/get?shopId=${this.shopId}`)
      if (Array.isArray(result.data)) {
        // alert('find')
        if (result.data[0].liffMainIDLoyalty !== null) {
          this.$liffId = result.data[0].liffMainIDLoyalty
        } else {
          this.$liffId = '1656906322-JN5MM8Ep'
        }
      } else {
        this.$liffId = '1656906322-JN5MM8Ep'
      }
    }
  }
}
</script>
<style scoped>
.component {
  z-index: 1;
}
.wave {
  position: absolute;
  z-index: 0;
}
.carousel {
  background: rgb(255, 255, 255);
  height: 200px;
}

.carousel-cell {
  width: 70%;
  height: 500px;
  background: rgb(255, 255, 255);
}

/* cell number */
.carousel-cell:before {
  display: block;
  text-align: center;
  line-height: 150px;
  font-size: 80px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/PromotionHome.vue